import { Injectable } from '@angular/core';
import { AnnouncerService } from '../announcer/announcer.service';

@Injectable({ providedIn: 'root' })
export class CustomErrorLoggerService {
  constructor(private readonly announcerService: AnnouncerService) {
  }

  logError = (message: string) => this.announcerService.onError(message);
}
